import React from "react";
import CustomButton from "../AuthenticationComponents/CustomButton";
import arrowRightIcon from "../../assets/images/authentication/arrow-right.svg";
import blueArrow from "../../assets/images/user-dashboard/arrow-right-blue.svg";
import "../../assets/scss/custom/components/_card-banner.scss";

/* -------------------------------------------------------------------------
 * CardConnectBanner — promo banner prompting the user to connect a
 * payment card to unlock 5% cashback. Styles live in style.css / style.scss.
 * ---------------------------------------------------------------------- */

const CardConnectBanner = ({ onConnect, onLearnMore }) => (
  <div className="card-connect-banner">
    <div className="card-connect-banner__icon-stack">
      <div className="card-connect-banner__card card-connect-banner__card--back" />
      <div className="card-connect-banner__card card-connect-banner__card--front">
        <div className="card-connect-banner__chip" />
        <div className="card-connect-banner__lines">
          <span />
          <span />
          <span />
        </div>
      </div>
    </div>

    <div className="card-connect-banner__content">
      <h2>
        You’re Missing Out on <b>5%</b> Back
      </h2>
      <p>
        You're all set to dine. But you haven't attached a payment account yet. <br/>
        So you're missing 5% back on every meal at partner restaurants.
      </p>
      <p
        className="card-connect-banner__learn-link"
        onClick={onLearnMore}
      >
        Learn how it works and why
        <img src={blueArrow} alt="blue-arrow"/>
      </p>
    </div>

    <CustomButton
                variant="blue"
                iconPosition="right"
                icon={arrowRightIcon}
                loading={false}
                className="card-connect-banner__connect-btn"
      onClick={onConnect}
    >
      Connect Account

    </CustomButton>
  </div>
);

export default CardConnectBanner;